import FakeNewsDetector from './FakeNewsDetector';

function App() {
  return <FakeNewsDetector />;
}

export default App;
